module.exports = __webpack_public_path__ + "img/niews-3.4056e2ea.jpeg";